import type { InputHTMLAttributes, SelectHTMLAttributes } from 'react';

import { cn } from '../lib/cn.js';

const base =
  'h-9 w-full rounded-md border border-input bg-background px-3 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50';

export const Input = ({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>): React.JSX.Element => (
  <input className={cn(base, className)} {...props} />
);

export const Select = ({
  className,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>): React.JSX.Element => (
  <select className={cn(base, 'pr-8', className)} {...props} />
);

/** Label + control + optional hint/error, so spacing is consistent everywhere. */
export const Field = ({
  label,
  htmlFor,
  hint,
  error,
  children,
  className,
}: {
  label: string;
  htmlFor: string;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element => (
  <div className={cn('space-y-1.5', className)}>
    <label htmlFor={htmlFor} className="text-sm font-medium leading-none">
      {label}
    </label>
    {children}
    {error ? (
      <p className="text-xs text-destructive">{error}</p>
    ) : hint ? (
      <p className="text-xs text-muted-foreground">{hint}</p>
    ) : null}
  </div>
);
